const password = {
    unsupported_encryption_method: "La méthode de cryptage {{name}} n'est pas prise en charge.",
    pepper_not_found: 'Mot de passe pepper non trouvé. Veuillez vérifier votre environnement de base.',
};
export default password;
